<template>
	<AsiCardDetail :title="$t('item.stockStateOverride')" :icon="icons.state"
	               :show-action-button="!readonly" :action-button-disabled="disabled" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :icon="icons.state" :label="$t('item.stockState')">
			<AsiAlert class="mt-3" dense text :type="alertType" :icon="icons.shipping" no-bottom-margin tile>
				{{ stockState }}
			</AsiAlert>
		</AsiCardDetailEntry>

		<ItemUpdateDialogStockState v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen" :item="item"
		                       @cancel="updateDialog.close()" @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop} from "vue-property-decorator";
	import ItemStateChip from "@/components/item/ItemStateChip.vue";
	import {IItemShop} from "@/models/item/ItemShopModels";
	import {IItemAdmin} from "@/models/item/ItemAdminModels";
	import Icon from "../../../plugins/icons";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import DialogHandler from "@/components/common/DialogHandler";
	import ItemUpdateDialogStockState from "@/components/item/admin/ItemUpdateDialogStockState.vue";
	import AsiAlert from "@/components/common/AsiAlert.vue";
	import {StockStatus} from "@/helpers/constants";
	import EnumHelper from "@/helpers/EnumHelper";
	import StockStatusHelper from "@/helpers/StockStatusHelper";


	@Component({
		components: {AsiAlert, ItemUpdateDialogStockState, AsiCardDetailEntry, AsiCardDetail, ItemStateChip}
	})
	export default class ItemCardStockState extends Vue {
		@Prop({type: Object, required: true})
		public item!:  IItemShop | IItemAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		@Prop({type: Boolean, default: false})
		public disabled!: boolean;

		private icons = Icon;
		private updateDialog: DialogHandler = new DialogHandler();

		@Emit('change')
		public change(): void {
			return;
		}

		private get stockState(): string {
			if (this.item.stockStatusOverride === null) {
				return this.$t('constants.noOverride').toString();
			}

			return EnumHelper.textFromValue(StockStatus, this.item.stockStatusOverride, true) ?? '';
		}

		private get alertType(): string {
			return StockStatusHelper.toAlertType(this.item.stockStatusOverride);
		}

	}
</script>

<style lang="scss" scoped>

</style>
